import { FolderSearch } from 'lucide-react'

interface EmptyContentProps {
  title?: string
  description?: string
  icon?: React.ReactNode
}

export const EmptyContent = ({
  title,
  description,
  icon,
}: EmptyContentProps) => {
  return (
    <div className="mt-20 flex w-full flex-col items-center justify-center gap-1">
      {icon || <FolderSearch size={46} />}
      <h1 className="mt-2 text-center text-lg font-bold">
        {title || 'Nenhum cliente encontrado'}
      </h1>
      <h2 className="mx-auto w-[70%] text-center text-gray-500">
        {description ||
          'Não encontramos resultados para essa busca. Verifique se o nome está correto e tente novamente.'}
      </h2>
    </div>
  )
}
